import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Utility function to detect if we're in an Auth0 callback state
const isAuth0Callback = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has('code') && urlParams.has('state');
};

const LoggedOutPage = () => {
  const { user, loginWithRedirect, isLoading, isAuthenticated } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    console.log('LoggedOutPage useEffect triggered');

    // Don't trigger redirect if we're in a callback state - let Auth0 handle it
    if (isAuth0Callback()) {
      console.log('In Auth0 callback state, letting Auth0 process...');
      return;
    }

    // Wait until Auth0 SDK is done loading
    if (isLoading) {
      return; // Do nothing while loading
    }

    if (!isAuthenticated) {
      console.log('Not authenticated, triggering login redirect...');
      loginWithRedirect({
        authorizationParams: {
          prompt: 'login' // Force fresh login to bypass any cache
        }
      });
    } else {
      console.log('User is authenticated:', user);
      // If authenticated, navigate to the dashboard
      navigate('/create');
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, navigate, user]);

  // Show different loading messages based on state
  if (isLoading || isAuth0Callback()) {
    return (
      <div>
        {isAuth0Callback()
          ? 'Completing authentication...'
          : 'Loading authentication status...'}
      </div>
    );
  }

  return (
    <div>
      <h1>Logged Out</h1>
      <p>You are being redirected to log in...</p>
    </div>
  );
};

export default LoggedOutPage;
